type Props = {
    completed: number;
};

const ProgressBar = (props: Props) => {
    const { completed } = props;

    return (
        <div className="loader-wrapper ">
            <div className="progress_bar">
                <div className="progress_bar-completed_at" style={{ width: `${completed}%` }}>
                    <span className="progress_bar-filler">{`${completed}%`}</span>
                </div>
            </div>
        </div>
    );
};

export default ProgressBar;
